import script from "./QModalOrderAct.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalOrderAct.vue?vue&type=script&setup=true&lang=js"

import "./QModalOrderAct.vue?vue&type=style&index=0&id=8fbe5564&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fbe5564"]])

export default __exports__